module.exports = __webpack_public_path__ + "img/crown.17425a19.svg";